var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKeyboardIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 35,
    viewBox: "0 0 50 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 35,
    rx: 2,
    fill: "#F7931E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 11.4,
    width: 5,
    height: 4.20002,
    rx: 1,
    fill: "#C4C4C4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 11.4,
    width: 5,
    height: 4.20002,
    rx: 1,
    fill: "#29ABE2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 5,
    height: 4.20002,
    rx: 1,
    fill: "#29ABE2"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 3,
    width: 5,
    height: 4.20002,
    rx: 1,
    fill: "#29ABE2"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 3,
    width: 5,
    height: 4.20002,
    rx: 1,
    fill: "#29ABE2"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 3,
    width: 5,
    height: 4.20002,
    rx: 1,
    fill: "#29ABE2"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 3,
    width: 5,
    height: 4.20002,
    rx: 1,
    fill: "#29ABE2"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 19.8,
    width: 5,
    height: 4.20002,
    rx: 1,
    fill: "#29ABE2"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 11.4,
    width: 5,
    height: 4.20002,
    rx: 1,
    fill: "#29ABE2"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 19.8,
    width: 5,
    height: 4.20002,
    rx: 1,
    fill: "#29ABE2"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 11.4,
    width: 5,
    height: 4.20002,
    rx: 1,
    fill: "#29ABE2"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 11.4,
    width: 5,
    height: 4.20002,
    rx: 1,
    fill: "#29ABE2"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 11.4,
    width: 5,
    height: 4.20002,
    rx: 1,
    fill: "#29ABE2"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 19.8,
    width: 5,
    height: 4.20002,
    rx: 1,
    fill: "#29ABE2"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 19.8,
    width: 5,
    height: 4.20002,
    rx: 1,
    fill: "#29ABE2"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 19.8,
    width: 5,
    height: 4.20002,
    rx: 1,
    fill: "#29ABE2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6363 29.1667C13.6363 28.0928 14.5069 27.2223 15.5808 27.2223H34.4192C35.4931 27.2223 36.3636 28.0928 36.3636 29.1667V29.1667C36.3636 30.2406 35.4931 31.1112 34.4192 31.1112H15.5808C14.5069 31.1112 13.6363 30.2406 13.6363 29.1667V29.1667Z",
    fill: "#29ABE2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyboardIcon);
export default __webpack_public_path__ + "static/media/KeyboardIcon.269bcbd3ee87095503ebefd5a104d2da.svg";
export { ForwardRef as ReactComponent };